<template>
  <div class="">
    <ToastAlert
      :is-active="toastAlert"
      :type="typeMsg"
      :message="msg"
      :title="tittle"
    />

    <div
      v-if="loader_page"
      class="fixed inset-0 flex items-center justify-center bg-white z-50"
    >
      <img
        src="@/assets/imgs/tuin_loader_v2.gif"
        alt="cargando..."
        class="w-[500px]"
      >
    </div>

    <div v-if="!loader_page">
      <!-- Mapa del sitio  -->

      <div
        v-if="!loader_page"
        class="w-full  overflow-hidden bg-white mt-4  font-poppins"
      >
        <div class="mx-auto px-4 md:p-0 w-full max-w-md bg-white flex flex-wrap ">
          <div class="flex flex-col mt-5 mb-6">
            <h2 class="md:text-[32px] text-[22px] font-medium">
              Cambiar Contraseña
            </h2>
            <p v-if="hasPassword" class="md:text-sm text-base mt-4">
              Ingresa tu contraseña actual. Luego, escribe una nueva contraseña y confírmala para completar el cambio.
            </p>
            <p v-else class="md:text-sm text-base mt-4">
              Escribe una nueva contraseña (mínimo 8 caracteres) y confírmala para completar el cambio.
            </p>
          </div>

          <div class="w-full mb-4 sm:mb-0">
            <!-- Form -->
            
            <div class="md:space-y-6 space-y-4">
              <!-- Old Password - Solo mostrar si el usuario tiene contraseña -->
              <div v-if="hasPassword">
                <!-- Contraseña Actual-->
                <div>
                  <PasswordInputComponent
                    v-model="old_password"
                    id="old_password"
                    name="old_password"
                    label="Contraseña Actual"
                    placeholder="Ingresa tu contraseña actual"
                    :error="errors.old_password"
                  />
                  <p v-if="errors.old_password" class="mt-1 text-sm font-medium text-red-600">{{ errors.old_password}}</p>
                </div>
              </div>

              <div class="">
                <div>
                    <ValidatedPasswordInput
                      v-model="password"
                      id="password"
                      name="password"
                      label="Nueva Contraseña"
                      placeholder="Ingresa tu contraseña"
                      :error="errors.password"
                      @blur="validatePassword"
                    />
                    <p v-if="errors.password" class="mt-1 text-sm font-medium text-red-600">{{ errors.password }}</p>
                </div>
              </div>

              <div>
                <!-- Confirmar contraseña -->
                <div>
                  <PasswordInputComponent
                    v-model="c_password"
                    id="confirm-password"
                    name="confirm-password"
                    label="Confirmar Contraseña"
                    placeholder="Confirma tu contraseña"
                    :error="errors.c_password"
                    @blur="validatePasswordConfirmation"
                  />
                  <p v-if="errors.c_password" class="mt-1 text-sm font-medium text-red-600">{{ errors.c_password }}</p>
                </div>
              </div>
            </div>

            <div class="flex flex-col">
              <div class="flex flex-1 justify-end items-end mt-6">
                <fwb-button
                  class="bg-tuin-100 hover:bg-tuin_hover text-sm font-medium text-white focus:outline-none focus:ring-transparent"
                  size="xl"
                  @click="save()"
                >
                  Guardar
                </fwb-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import {
  //FwbBreadcrumb,
  //FwbBreadcrumbItem,
  //FwbHeading,
  FwbButton,
  //FwbInput,
} from "flowbite-vue";
import { ref, computed, onMounted, watch } from "vue";
import ToastAlert from "@/commond/ToastAlert.vue";
import ValidatedPasswordInput from '@/components/ValidatedPasswordInput.vue'
import PasswordInputComponent from '@/components/PasswordInputComponent.vue'
import axios from "axios";
import { useRouter } from "vue-router";
let router = useRouter();
import { useStore } from "vuex";
const store = useStore();
let session = computed(() => store.getters.getUserSession);

let loader_page = ref(false);
let userProfile = ref(null);
let hasPassword = ref(false);

let old_password = ref("");
let password = ref("");
let c_password = ref("");
//let password_confirmation = ref("")

let toastAlert = ref(false);
let typeMsg = ref("");
let msg = ref("");
let tittle = ref("")

// Estado de errores
const errors = ref({
  c_password: '',
  password: '',
})

// Función para validar la contraseña
function validatePassword() {
  errors.value.password = '';
  
  if (!password.value) {
    return false;
  }
  
  if (password.value.length < 8) {
    errors.value.password = 'La contraseña debe tener al menos 8 caracteres';
    return false;
  }
  
  return true;
}

async function save() {
  // Validar que si hay contraseña, se debe ingresar la actual
  if (hasPassword.value && old_password.value.length == 0) {
    showToast("danger", "Debes ingresar tu contraseña actual");
    return;
  }

  if (password.value.length == 0 || c_password.value.length == 0) {
    showToast("danger", "Debes ingresar todos los campos de nueva contraseña");
    return;
  }

  if (password.value.length < 8) {
    showToast("danger", "La contraseña debe tener al menos 8 caracteres");
    return;
  }

  if (password.value != c_password.value) {
    showToast("danger", "La contraseña y confirmar contraseña no coinciden");
    return;
  }

  let post_form = {
    new_password: password.value,
    broker_id: session.value.id,
  };

  // Si hay contraseña actual, la incluimos en la petición
  if (hasPassword.value) {
    post_form.password = old_password.value;
  }

  let options = {
    headers: {
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  let url_link = `${process.env.VUE_APP_API_BASE_URL}/broker/profile/change-password`;
  try {
    const response = await axios.put(url_link, post_form, options);

    if (response.status == 401) {
      store.dispatch("clearUserSession");
    }

    if (response.status == 200) {
      loader_page.value = false;
      showToast("success", "Contraseña actualizada correctamente");
      old_password.value = "";
      password.value = "";
      c_password.value = "";
    }
  } catch (error) {
    if (error.response && error.response.status == 422) {
      console.log(error.response);
      showToast("danger", error.response.data.message);
    }
  }
}

function validatePasswordConfirmation() {
  errors.value.c_password = ''
  
  if (!c_password.value) {
    return false
  }
  
  if (c_password.value !== password.value) {
    errors.value.c_password = 'La contraseña no es la misma'
    return false
  }
  
  return true
}

const getProfile = async () => {
  loader_page.value = true;
  
  if (!session.value || !session.value.token_api || !session.value.id) {
    showToast("danger", "No se encontró la sesión del usuario. Vuelve a iniciar sesión.");
    loader_page.value = false;
    return;
  }
  
  try {
    let options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };
    
    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/broker/profile/${session.value.id}`,
      options
    );
    
    if (response.status === 200) {
      // Guardar datos del perfil
      userProfile.value = response.data.resp;
      
      // Verificar explícitamente si el usuario tiene contraseña
      console.log("Password status:", userProfile.value?.info?.password);
      
      // Asignar hasPassword directamente después de obtener los datos
      hasPassword.value = Boolean(userProfile.value?.info?.password);
      
      // Verificación adicional para asegurar que el valor sea correcto
      console.log("¿Usuario tiene contraseña?:", hasPassword.value);
      
      loader_page.value = false;
    }
  } catch (err) {
    console.error("Error al obtener datos del perfil:", err);
    if (err.response && err.response.status === 401) {
      store.dispatch("clearUserSession");
      router.push({ name: 'login' });
    } else {
      showToast("danger", "Error al cargar los datos del perfil. Inténtalo nuevamente.");
    }
    loader_page.value = false;
  }
};

// Observador para verificar cambios en userProfile
watch(() => userProfile.value, (newProfile) => {
  if (newProfile) {
    // Actualizar hasPassword cada vez que cambie el perfil
    hasPassword.value = Boolean(newProfile?.info?.password);
    console.log("userProfile actualizado, hasPassword:", hasPassword.value);
  }
}, { deep: true });

async function showToast(type, message, tittl) {
  toastAlert.value = true;
  typeMsg.value = type;
  msg.value = message;
  tittle.value = tittl;

  setTimeout(() => {
    closeToast();
  }, 3000);
}

async function closeToast() {
  toastAlert.value = false;
  typeMsg.value = "";
  msg.value = "";
  tittle.value = "";
}

onMounted(() => {  
  getProfile();    
});
</script>